import axios from 'axios';
import qs from 'qs';
import { Client } from './client';

export function fetchTimeLeft() {
  return axios.get('/services/warehouse_open/');
}

export function fetchUsps(type) {
  return axios.get(`/api/get_usp/${type || ''}`);
}

export function fetchOffers(sku_id) {
  return axios.get(`/api/promotions/get/${sku_id}/`);
}

export function postToCart(id, size, amount) {
  const postData = {
    product_id: id,
    size,
    amount: amount || 1,
  };
  return Client().post('/cart/items/add_to_cart/', qs.stringify(postData));
}

export function postCustomization(id, customizationData) {
  return Client().post(
    `/customizations/update/${id}/`,
    qs.stringify(customizationData)
  );
}

export function postToSizemonitor(product_id, size_id, email) {
  const postData = {
    product_id,
    size_id,
    email,
  };

  return Client().post('/services/sizemonitor/', qs.stringify(postData));
}

export function addMultibuy(product_id, size_id, amount) {
  const postData = {
    product: {
      product_id,
      size_id,
      amount,
    },
    subproducts: [],
    promotions: [],
  };
  return Client().post('/cart/items/new_cart/', postData);
}

export function addPackageToCart(id, data) {
  const subproducts = data.map(({ product_id, size_id }) => {
    return {
      product_id,
      size_id,
      amount: 1,
    };
  });
  const postData = {
    product: {
      product_id: id,
      amount: 1,
    },
    subproducts,
    promotions: [],
  };
  return Client().post('/cart/items/new_cart/', postData);
}

export function fetchProductSliderIds(id) {
  return axios.get(`/api/sliders/morelikethis/?products=${id}`);
}

export function fetchProductSlider(ids) {
  return axios.get(`/api/products/batch/?list=${ids}`);
}

export function postUNIID() {
  return new Promise((resolve) =>
    // eslint-disable-next-line no-promise-executor-return
    setTimeout(() => {
      resolve({ success: true });
    }, 1000)
  );
}
